import React from 'react';
import {
  EUserType,
  EPositionType,
  EDegreeType,
  EJobType,
  ECountryType,
  EAvailableTimeTypes,
} from 'enums/base.enum';
import { PrimaryColor, MenteeColor } from 'GlobalStyles';

export const CUserType = {
  [EUserType.Mentee]: '멘티',
  [EUserType.Mentor]: '멘토',
  [EUserType.Kaitus]: '카이투스',
  [EUserType.Kaitus_LG]: '카이투스',
  [EUserType.Kaitus_DN]: '카이투스'
};

export const CUserTypeColor = {
  [EUserType.Mentee]: MenteeColor,
  [EUserType.Mentor]: PrimaryColor,
  [EUserType.Kaitus]: PrimaryColor,
  [EUserType.Kaitus_LG]: PrimaryColor,
  [EUserType.Kaitus_DN]: PrimaryColor
};

export const CDegreeType = {
  [EDegreeType.Bachelor]: '학사',
  [EDegreeType.Master]: '석사',
  [EDegreeType.Doctor]: '박사',
  [EDegreeType.MBA]: 'MBA',
};

export const CJobType = {
  [EJobType.Current]: '현직',
  [EJobType.Former]: '전직',
};

export const CPositionType = {
  [EPositionType.Junior]: '주니어',
  [EPositionType.Leadership]: '시니어(인터뷰어 출신)',
};

export const CCountryType = {
  [ECountryType.KR]: '한국',
  [ECountryType.US]: '미국',
  [ECountryType.UK]: '영국',
  [ECountryType.CN]: '중국',
  [ECountryType.JP]: '일본',
  [ECountryType.ETC]: '기타',
};

export const CAvailableTimeTypes = {
  [EAvailableTimeTypes.Today]: '오늘 가능한 멘토',
  [EAvailableTimeTypes.SevenDays]: '7일 내에 가능한 멘토',
  [EAvailableTimeTypes.FourteenDays]: '14일 내에 가능한 멘토',
};
